import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import * as moment from 'moment';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import UploadSpecification from 'web/components/UploadSpecification';
import DatePicker from "web/components/form-elements/DatePicker";
import TimeField from 'react-simple-timefield';
import { getInitialValues, getRegisterSchema } from 'web/components/utils/uploadBolUtils';

import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import './bolUpload.scss';
import styled from 'styled-components';
export default ({ isOpen, toggle, title, type, alertType, content, link, postType, callBackBOL, uploadType, selectedItem }) => {
  let fileArr = []
  const [imageArrState, setImageArrState] = useState()
  const redirectLink = () => {
    toggle(!isOpen)
  }

  let deliveryDate, deliveryTime, deliveryType = ''
  if (selectedItem && selectedItem.contactInfo && selectedItem.contactInfo.type === "DELIVERABLE") deliveryType = 'Delivery'
  else deliveryType = 'PickUp'
  if (uploadType === 'reUpload' && selectedItem) {
      let deliveryDateTemp
      if (selectedItem.userType === 'BUYER') deliveryDateTemp = selectedItem.buyerDeliveryDate
      else deliveryDateTemp = selectedItem.sellerDeliveryDate
      deliveryDate = moment(deliveryDateTemp).format("MM/DD/YYYY hh:mm a")
      let ampm = deliveryDate.substring(deliveryDate.length - 2, deliveryDate.length)
      deliveryTime = deliveryDate.substring(deliveryDate.length - 8, deliveryDate.length - 3)
      if (ampm === "pm") {
        let deliveryTimeHour = String(parseInt(deliveryTime.substring(0, 2)) + 12)
        deliveryTime = deliveryTimeHour + deliveryTime.substring(2, 5)
      }
    } else {
      deliveryDate = new Date()
      let hours = new Date().getHours()
      let mins = new Date().getMinutes()
      if (hours < 10) hours = "0" + hours
      if (mins < 10) mins = "0" + mins
      deliveryTime = hours + ':' + mins
    }

  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='alertModal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              redirectLink()
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3></h3>
          </div>
          <Formik
            initialValues={getInitialValues(uploadType, selectedItem)}
            validationSchema={getRegisterSchema(uploadType, selectedItem)}
            onSubmit={(values) => { }}>
            {(props) => {
              const {
                isValid,
                dirty,
                setFieldValue,
              } = props;

                return (
                  <>
                    <Form>
                      <ModalBody>
                        <UploadSection>
                          {uploadType === 'claimReUpload' ?
                            <div className="modal-content">
                              <p className=''>Please re-upload the BOL/POD with a valid Proof of Delivery (POD) to finalize the order process and resolve the claim.</p>
                            </div>
                            :
                            <div>
                              <div className="modal-content">
                                <p className=''>{`Please confirm this order has been ${deliveryType === 'Delivery' ? 'delivered' : 'picked up'}. Please input the actual ${deliveryType === 'Delivery' ? 'Delivery' : 'pick up'} date & time. Please upload the BOL/POD with a valid Proof of Delivery (POD) to finalize the order process.`}</p>
                              </div>
                              <div>
                                <p className='my-3' style={{ textAlign: 'left' }}>{`${deliveryType === 'Delivery' ? 'Delivery' : 'Pick up'} Date`}</p>
                                <div className='row'>
                                  <div className='col-md-6 col-sm-12 mb-2'>
                                    <DatePicker
                                      disabled={uploadType === 'reUpload'}
                                      name="orderDeliveryDate"
                                      placeholderText=""
                                      callBackFun={(date) => {
                                        setFieldValue('orderDeliveryDate', date)
                                      }}
                                      uploadType={uploadType}
                                      selectedDate={selectedItem && selectedItem.userType === 'BUYER' ? selectedItem.buyerDeliveryDate : selectedItem.sellerDeliveryDate}
                                    />
                                  </div>
                                  <div className='col-md-6 col-sm-12'>
                                    <div className='app-input-text'>
                                      <TimeField
                                        style={{ opacity: uploadType === 'reUpload' ? 0.5 : 1 }}
                                      disabled={uploadType === 'reUpload'}
                                      className='s-input -time'
                                      name='orderDeliveryTime'
                                      value={deliveryTime && deliveryTime}
                                      onChange={(time) => {
                                        setFieldValue('orderDeliveryTime', time.target.value)
                                      }} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        <div className='modal-content upload-input-sec'>
                          <UploadSpecification
                            name="bolDocument"
                            props={props}
                            ProfileName=""
                            CompanyName=""
                            pageType=""
                            fileArr={fileArr}
                            acceptFiles="image/png,image/jpeg,image/gif,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            imageLoadCallBack={(imageArr) => {
                            }}
                            callBackFun={(imageArr) => {
                              setFieldValue('bolDocument', imageArr)
                              setImageArrState(imageArr);
                            }}
                          />
                        </div>
                      </UploadSection>
                    </ModalBody>
                    <ModalFooter className='modal-footer'>
                      <Button
                        type='app-green-button submitBtn'
                        disabled={!(isValid && dirty)}
                        handleClick={() => {
                          callBackBOL(props.values)
                          redirectLink()
                        }}>
                        Submit
                      </Button>
                    </ModalFooter>
                  </Form>
                </>
              );
            }}
          </Formik>
        </div>
      </Modal>
    </div>
  );
};

const UploadSection = styled.div`
    align-items: center;
    .custom-file-input::before {
      padding: 9px 1px;
    }
    .custom-file-input {
      max-width: 141px;
    }
  `